/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedLifecycleStage
 */
export interface PatchedLifecycleStage {
  /**
   *
   * @type {number}
   * @memberof PatchedLifecycleStage
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedLifecycleStage
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedLifecycleStage
   */
  order?: number;
}

/**
 * Check if a given object implements the PatchedLifecycleStage interface.
 */
export function instanceOfPatchedLifecycleStage(value: object): value is PatchedLifecycleStage {
  return true;
}

export function PatchedLifecycleStageFromJSON(json: any): PatchedLifecycleStage {
  return PatchedLifecycleStageFromJSONTyped(json, false);
}

export function PatchedLifecycleStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedLifecycleStage {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    order: json['order'] == null ? undefined : json['order'],
  };
}

export function PatchedLifecycleStageToJSON(value?: Omit<PatchedLifecycleStage, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    order: value['order'],
  };
}
